import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Container, TextField, Grid, List, ListItem,
  IconButton, Divider, Typography, Select, MenuItem, FormControl,
  InputLabel, Paper, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  OutlinedInput, InputAdornment, Switch, CircularProgress,
} from '@mui/material';
import ActionButton from '../../components/ActionButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';
import { toast, Toaster } from 'sonner';
import { FormControlLabel, Checkbox, Button } from '@mui/material';
import { TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { format } from 'date-fns';

const fetchAvailability = async (userId) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/calendar/get-availability`, {
      params: { userId }
    });
    if (Array.isArray(response.data)) {
      return response.data;
    } else {
      console.error('Unexpected availability data format:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching availability:', error);
    if (error.response) {
      console.error('Error response:', error.response.data);
    }
    return [];
  }
};

const ContactPage = () => {
const [availabilityExpanded, setAvailabilityExpanded] = useState(false);
const [isLoadingAvailability, setIsLoadingAvailability] = useState(false);
  const [newEntityAvailability, setNewEntityAvailability] = useState({
    monday: { available: false, slots: [] },
    tuesday: { available: false, slots: [] },
    wednesday: { available: false, slots: [] },
    thursday: { available: false, slots: [] },
    friday: { available: false, slots: [] },
    saturday: { available: false, slots: [] },
    sunday: { available: false, slots: [] },
  });

  const handleNewEntityAvailabilityChange = (day, field, value, index = null) => {
    setNewEntityAvailability((prev) => {
      const updatedDay = { ...prev[day] };
      if (field === 'available') {
        updatedDay.available = value;
        if (!value) {
          updatedDay.slots = [];
        }
      } else if (field === 'startTime' || field === 'endTime') {
        updatedDay.slots[index] = { ...updatedDay.slots[index], [field]: value };
      }
      return { ...prev, [day]: updatedDay };
    });
  };

  const handleAddTimeSlot = (day) => {
    setNewEntityAvailability((prev) => {
      const updatedDay = { ...prev[day] };
      updatedDay.slots.push({ startTime: null, endTime: null });
      return { ...prev, [day]: updatedDay };
    });
  };

  const handleRemoveTimeSlot = (day, index) => {
    setNewEntityAvailability((prev) => {
      const updatedDay = { ...prev[day] };
      updatedDay.slots.splice(index, 1);
      return { ...prev, [day]: updatedDay };
    });
  };
  const [userId, setUserId] = useState(null);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState({ type: null, id: null });
  const [editData, setEditData] = useState({
    branch: { name: '', address: '', country: '', state: '', pinCode: '', availability: '' },
    department: { departmentName: '', entityName: '', entityNumber: '' }
  });

  const [newBranch, setNewBranch] = useState({
    name: '',
    address: '',
    country: '',
    state: '',
    pinCode: '',
    availability: '',
  });

const [openAvailabilityDialog, setOpenAvailabilityDialog] = useState(false);
const [openEditAvailabilityDialog, setOpenEditAvailabilityDialog] = useState(false);
const [branchAvailability, setBranchAvailability] = useState({
    monday: { available: true, startTime: '09:00', endTime: '17:00' },
    tuesday: { available: true, startTime: '09:00', endTime: '17:00' },
    wednesday: { available: true, startTime: '09:00', endTime: '17:00' },
    thursday: { available: true, startTime: '09:00', endTime: '17:00' },
    friday: { available: true, startTime: '09:00', endTime: '17:00' },
    saturday: { available: false, startTime: '09:00', endTime: '17:00' },
    sunday: { available: false, startTime: '09:00', endTime: '17:00' },
  });
  const [selectedBranch, setSelectedBranch] = useState('');
  const [newDepartment, setNewDepartment] = useState({
    departmentName: '',
    entityName: '',
    entityNumber: '',
    isCustomDepartment: false,
    customDepartmentName: ''
  });
  const [deleteConfirmation, setDeleteConfirmation] = useState({ 
    open: false, 
    branchId: null, 
    deptId: null,
    type: null // 'branch' or 'department'
  });

  const countries = ['India']; // Add more countries as needed
  const states = {
    India: [
      'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Delhi', 'Goa', 'Gujarat', 
      'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 
      'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 
      'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 
      'West Bengal'
    ],
    // Add more countries and their states as needed
  };
  const departments = [
    'Custom',
    'Accounting',
    'Administration',
    'Customer Service',
    'Engineering',
    'Finance',
    'Human Resources',
    'Information Technology',
    'Legal',
    'Marketing',
    'Operations',
    'Product Management',
    'Public Relations',
    'Quality Assurance',
    'Research and Development',
    'Sales',
    'Security',
    'Supply Chain',
    'Training'
  ];

  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    const initializeData = async (userId) => {
      setLoading(true);
      try {
        await fetchBranches(userId);
        const globalAvailabilityData = await fetchAvailability(userId);
        const updatedAvailability = {};

        if (Array.isArray(globalAvailabilityData) && globalAvailabilityData.length > 0) {
          globalAvailabilityData.forEach(({ weekday, startTime, endTime }) => {
            const lowercaseWeekday = weekday.toLowerCase();
            updatedAvailability[lowercaseWeekday] = {
              available: false,
              globalStartTime: new Date(`1970-01-01T${startTime}`),
              globalEndTime: new Date(`1970-01-01T${endTime}`),
              slots: [],
              editable: true
            };
          });
        } else {
          console.error('No global availability data found');
        }
        setNewEntityAvailability(updatedAvailability);
      } catch (error) {
        console.error('Error initializing data:', error);
        toast.error('Failed to initialize data. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    if (storedUserId) {
      setUserId(storedUserId);
      initializeData(storedUserId);
    } else {
      toast.error('User not found. Please log in again.');
      window.location.href = 'https://www.verbalyze.in/login';
    }
  }, []);

  useEffect(() => {
    console.log('Current branches state:', branches);
  }, [branches]);

  const fetchBranches = async (id) => {
    setLoading(true);
    try {
      console.log('Fetching branches for user ID:', id);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/branch/branches/${id}`);
      console.log('Raw response:', response.data);
      if (response.data.branches) {
        const branchesWithDepartments = response.data.branches.map(branch => ({
          ...branch,
          departments: Array.isArray(branch.departments) ? branch.departments : []
        }));
        console.log('Processed branches:', JSON.stringify(branchesWithDepartments, null, 2));
        setBranches(branchesWithDepartments);
      } else {
        console.log('No branches found in response');
        setBranches([]);
      }
    } catch (error) {
      console.error('Error fetching branches:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error', error.message);
      }
      toast.error('Failed to fetch branches. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleBranchChange = (event) => {
    const { name, value } = event.target;
    setNewBranch(prev => ({ ...prev, [name]: value }));
  };

  const handleOpenAvailabilityDialog = () => {
    setOpenAvailabilityDialog(true);
  };

  const handleCloseAvailabilityDialog = () => {
    setOpenAvailabilityDialog(false);
  };

  const handleOpenEditAvailabilityDialog = () => {
    const parsedAvailability = parseBranchAvailability(editData.branch.availability);
    setBranchAvailability(parsedAvailability);
    setOpenEditAvailabilityDialog(true);
  };

  const handleCloseEditAvailabilityDialog = () => {
    setOpenEditAvailabilityDialog(false);
  };

  const handleAvailabilityChange = (day, field, value) => {
    setBranchAvailability(prev => ({
      ...prev,
      [day]: { ...prev[day], [field]: value }
    }));
  };

  const handleSaveEditAvailability = () => {
    const availabilityObject = Object.entries(branchAvailability).reduce((acc, [day, data]) => {
      if (data.available) {
        acc[day] = {
          available: data.available,
          startTime: data.startTime,
          endTime: data.endTime
        };
      }
      return acc;
    }, {});

    const availabilityString = Object.keys(availabilityObject)
      .map(day => day.substring(0, 3).toUpperCase())
      .join(', ');

    setEditData(prev => ({
      ...prev,
      branch: {
        ...prev.branch,
        availability: availabilityObject
      }
    }));
    setBranches(branches.map(branch => 
      branch.id === editMode.id 
        ? { ...branch, availability: availabilityString } 
        : branch
    ));
    setOpenEditAvailabilityDialog(false);
  };

  const handleSaveAvailability = () => {
    const availabilityString = Object.entries(branchAvailability)
      .filter(([, { available }]) => available)
      .map(([day]) => day.substring(0, 3).toUpperCase())
      .join(', ');
    setNewBranch(prev => ({ ...prev, availability: availabilityString }));
    setOpenAvailabilityDialog(false);
  };

  const addBranch = async () => {
    if (!userId) {
      toast.error('User not found. Please log in again.');
      window.location.href = 'https://www.verbalyze.in/login';
      return;
    }
    if (Object.values(newBranch).every(field => field.trim() !== '')) {
      try {
        // Format the availability data correctly
        const availabilityObject = Object.entries(branchAvailability).reduce((acc, [day, data]) => {
          if (data.available) {
            acc[day] = {
              available: data.available,
              startTime: data.startTime,
              endTime: data.endTime
            };
          }
          return acc;
        }, {});

        const branchWithUserId = { 
          ...newBranch, 
          userId,
          availability: availabilityObject
        };
        console.log('Sending branch data:', branchWithUserId);
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/branch/addbranch`, branchWithUserId);
        const newBranchData = response.data.branch;
        
        // Update the branches state immediately
        setBranches(prev => [...prev, { ...newBranchData, departments: [] }]);
        
        setNewBranch({ name: '', address: '', country: '', state: '', pinCode: '', availability: '' });
        setBranchAvailability({
          monday: { available: true, startTime: '09:00', endTime: '17:00' },
          tuesday: { available: true, startTime: '09:00', endTime: '17:00' },
          wednesday: { available: true, startTime: '09:00', endTime: '17:00' },
          thursday: { available: true, startTime: '09:00', endTime: '17:00' },
          friday: { available: true, startTime: '09:00', endTime: '17:00' },
          saturday: { available: false, startTime: '09:00', endTime: '17:00' },
          sunday: { available: false, startTime: '09:00', endTime: '17:00' },
        });
        toast.success('Branch added successfully!');
        
        // Fetch all branches to ensure consistency
        fetchBranches(userId);
      } catch (error) {
        console.error('Error adding branch:', error);
        if (error.response) {
          console.error('Error response:', error.response.data);
          toast.error(`Failed to add branch: ${error.response.data.message}`);
        } else {
          toast.error('Failed to add branch. Please try again.');
        }
      }
    } else {
      toast.error('Please fill in all fields for the branch.');
    }
  };

  const handleEditClick = (type, id, data) => {
    setEditMode({ type, id });
    if (type === 'branch') {
      const parsedAvailability = parseBranchAvailability(data.availability);
      setEditData({ ...editData, branch: { ...data, availability: data.availability } });
      setBranchAvailability(parsedAvailability);
      console.log('Parsed availability:', parsedAvailability);
    } else {
      setEditData({ ...editData, department: { ...data } });
    }
  };

  const parseBranchAvailability = (availability) => {
    const defaultAvailability = {
      monday: { available: false, startTime: '09:00', endTime: '17:00' },
      tuesday: { available: false, startTime: '09:00', endTime: '17:00' },
      wednesday: { available: false, startTime: '09:00', endTime: '17:00' },
      thursday: { available: false, startTime: '09:00', endTime: '17:00' },
      friday: { available: false, startTime: '09:00', endTime: '17:00' },
      saturday: { available: false, startTime: '09:00', endTime: '17:00' },
      sunday: { available: false, startTime: '09:00', endTime: '17:00' },
    };

    if (!availability) return defaultAvailability;

    if (typeof availability === 'string') {
      // Handle string format (e.g., "MON, TUE, WED")
      const availableDays = availability.split(', ');
      availableDays.forEach(day => {
        const lowercaseDay = day.toLowerCase();
        if (defaultAvailability[lowercaseDay]) {
          defaultAvailability[lowercaseDay].available = true;
        }
      });
    } else if (typeof availability === 'object') {
      // Handle object format
      Object.entries(availability).forEach(([day, data]) => {
        const lowercaseDay = day.toLowerCase();
        if (defaultAvailability[lowercaseDay]) {
          defaultAvailability[lowercaseDay] = {
            available: true,
            startTime: data.startTime || '09:00',
            endTime: data.endTime || '17:00'
          };
        }
      });
    }

    return defaultAvailability;
  };

  const handleEditCancel = () => {
    setEditMode({ type: null, id: null });
    setEditData({
      branch: { name: '', address: '', country: '', state: '', pinCode: '' },
      department: { departmentName: '', entityName: '', entityNumber: '' }
    });
  };

const handleEditSave = async () => {
  try {
    if (editMode.type === 'branch') {
      const formattedAvailability = Object.entries(branchAvailability).reduce((acc, [day, data]) => {
        if (data.available) {
          acc[day] = {
            startTime: data.startTime,
            endTime: data.endTime
          };
        }
        return acc;
      }, {});

      const updatedBranchData = {
        ...editData.branch,
        availability: formattedAvailability
      };

      console.log('Updating branch with data:', updatedBranchData);

      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/branch/branches/${editMode.id}`,
        updatedBranchData
      );

      if (response.data) {
        setBranches(branches.map(branch => 
          branch.id === editMode.id ? { ...branch, ...updatedBranchData } : branch
        ));
        toast.success('Branch updated successfully!');
      }
      } else if (editMode.type === 'department') {
        const branch = branches.find(b => 
          b.departments?.some(d => d.uniqueId === editMode.id)
        );
        
        if (!branch) {
          console.error('Branch not found for department:', editMode.id);
          throw new Error('Branch not found');
        }

        const response = await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/branch/branches/${branch.id}/departments?departmentId=${editMode.id}`,
          editData.department
        );

        if (response.data) {
          setBranches(branches.map(b => {
            if (b.id === branch.id) {
              return {
                ...b,
                departments: b.departments.map(d =>
                  d.uniqueId === editMode.id ? { ...d, ...editData.department } : d
                )
              };
            }
            return b;
          }));
          toast.success('Department updated successfully!');
        }
      }
      handleEditCancel();
    } catch (error) {
      console.error('Error updating:', error);
      toast.error(error.response?.data?.message || 'Failed to update. Please try again.');
    }
  };

const handleDepartmentChange = (event) => {
    const { name, value } = event.target;
    if (name === 'departmentName' && value === 'Custom') {
      setNewDepartment(prev => ({ 
        ...prev, 
        [name]: value,
        isCustomDepartment: true,
        customDepartmentName: ''
      }));
    } else {
      setNewDepartment(prev => ({ 
        ...prev, 
        [name]: value,
        isCustomDepartment: false
      }));
    }
  };

const fetchBranchAvailability = async (branchId) => {
    console.log('Fetching availability for branch:', branchId);
    setIsLoadingAvailability(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/branch/availability/${branchId}`);
      console.log('Received availability data:', JSON.stringify(response.data, null, 2));
      if (response.data && response.data.availability && response.data.availability.M) {
        const fetchedAvailability = response.data.availability.M;
        setNewEntityAvailability(prev => {
          const updatedAvailability = {
            monday: { available: false, slots: [] },
            tuesday: { available: false, slots: [] },
            wednesday: { available: false, slots: [] },
            thursday: { available: false, slots: [] },
            friday: { available: false, slots: [] },
            saturday: { available: false, slots: [] },
            sunday: { available: false, slots: [] },
          };
          Object.keys(fetchedAvailability).forEach(day => {
            const lowercaseDay = day.toLowerCase();
            if (fetchedAvailability[day].M && fetchedAvailability[day].M.startTime && fetchedAvailability[day].M.endTime) {
              updatedAvailability[lowercaseDay] = {
                available: true,
                slots: []
              };
            }
          });
          console.log('Updated availability:', JSON.stringify(updatedAvailability, null, 2));
          return updatedAvailability;
        });
        setAvailabilityExpanded(true);
      } else {
        console.error('Invalid availability data structure:', JSON.stringify(response.data, null, 2));
        toast.error('Received invalid availability data structure');
        setNewEntityAvailability({
          monday: { available: false, slots: [] },
          tuesday: { available: false, slots: [] },
          wednesday: { available: false, slots: [] },
          thursday: { available: false, slots: [] },
          friday: { available: false, slots: [] },
          saturday: { available: false, slots: [] },
          sunday: { available: false, slots: [] },
        });
      }
    } catch (error) {
      console.error('Error fetching branch availability:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        console.error('Error status:', error.response.status);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error details:', error.message);
      }
      toast.error('Failed to fetch branch availability. Please try again.');
      setNewEntityAvailability({
        monday: { available: false, slots: [] },
        tuesday: { available: false, slots: [] },
        wednesday: { available: false, slots: [] },
        thursday: { available: false, slots: [] },
        friday: { available: false, slots: [] },
        saturday: { available: false, slots: [] },
        sunday: { available: false, slots: [] },
      });
    } finally {
      setIsLoadingAvailability(false);
    }
  };

const handleBranchSelect = (event) => {
    const selectedBranchName = event.target.value;
    console.log('Selected branch:', selectedBranchName);
    setSelectedBranch(selectedBranchName);
    const selectedBranchObj = branches.find(branch => branch.name === selectedBranchName);
    if (selectedBranchObj) {
      console.log('Fetching availability for branch ID:', selectedBranchObj.id);
      fetchBranchAvailability(selectedBranchObj.id);
    } else {
      console.log('No branch selected, resetting availability');
      setNewEntityAvailability({
        monday: { available: false, slots: [] },
        tuesday: { available: false, slots: [] },
        wednesday: { available: false, slots: [] },
        thursday: { available: false, slots: [] },
        friday: { available: false, slots: [] },
        saturday: { available: false, slots: [] },
        sunday: { available: false, slots: [] },
      });
      setAvailabilityExpanded(false);
    }
  };

const addDepartment = async () => {
  if (!selectedBranch || !newDepartment.entityName || !newDepartment.entityNumber) {
    toast.error('Please fill in all fields for the department.');
    return;
  }

  const selectedBranchObj = branches.find(branch => branch.name === selectedBranch);
  if (!selectedBranchObj) {
    toast.error('Selected branch not found.');
    return;
  }

  // Check for duplicate entity number locally before sending request
  const isDuplicateEntityNumber = selectedBranchObj.departments && selectedBranchObj.departments.some(
    dept => dept.entityNumber === newDepartment.entityNumber
  );
  if (isDuplicateEntityNumber) {
    toast.error('An entity with this number already exists in this branch. Please use a different number.');
    return;
  }

  try {
    // Format availability data
    const weekdays = [];
    const formattedAvailability = [];
    
    Object.entries(newEntityAvailability).forEach(([day, data]) => {
      const capitalizedDay = day.charAt(0).toUpperCase() + day.slice(1);
      if (data.available) {
        weekdays.push(capitalizedDay);
        const timeSlots = data.slots.length > 0 ? data.slots.map(slot => ({
          startTime: slot.startTime instanceof Date ? slot.startTime.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false}) : slot.startTime,
          endTime: slot.endTime instanceof Date ? slot.endTime.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false}) : slot.endTime
        })) : [{ startTime: '09:00', endTime: '17:00' }]; // Default time slot if no slots are defined
        formattedAvailability.push({
          weekday: capitalizedDay,
          timeSlots: timeSlots
        });
      }
    });

    // If no availability is set, use default values
    if (weekdays.length === 0 || formattedAvailability.length === 0) {
      const defaultDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
      defaultDays.forEach(day => {
        weekdays.push(day);
        formattedAvailability.push({
          weekday: day,
          timeSlots: [{
            startTime: '09:00',
            endTime: '17:00'
          }]
        });
      });
    }

    const departmentData = {
      ...newDepartment,
      departmentName: newDepartment.departmentName === 'Custom' ? newDepartment.customDepartmentName : newDepartment.departmentName,
      weekdays,
      availability: formattedAvailability
    };

    console.log('Data being sent to the server:', JSON.stringify(departmentData, null, 2));
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/branch/${selectedBranchObj.id}/department`,
      departmentData
    );
    console.log('Full server response:', JSON.stringify(response.data, null, 2));

    if (response.data && response.data.department) {
      const { department: newDepartmentData, updatedBranch, uniqueId } = response.data;

      if (!uniqueId) {
        console.error('Department uniqueId is missing in the response');
        toast.error('Failed to add department: uniqueId is missing in the response');
        return;
      }

      // Always use the formattedAvailability we created, as the server might not return it
      const departmentWithAvailability = {
        ...newDepartmentData,
        uniqueId,
        availability: formattedAvailability,
        weekdays
      };

      // Update the branches state with the new department
      setBranches(prevBranches =>
        prevBranches.map(branch =>
          branch.id === selectedBranchObj.id 
            ? { 
                ...branch, 
                departments: [...(branch.departments || []), departmentWithAvailability] 
              }
            : branch
        )
      );
      console.log('Updated branches after adding department:', JSON.stringify(branches, null, 2));

      // Clear all form fields
      setNewDepartment({
        departmentName: '',
        entityName: '',
        entityNumber: '',
        isCustomDepartment: false,
        customDepartmentName: ''
      });
      setSelectedBranch('');
      setNewEntityAvailability({
        monday: { available: false, slots: [] },
        tuesday: { available: false, slots: [] },
        wednesday: { available: false, slots: [] },
        thursday: { available: false, slots: [] },
        friday: { available: false, slots: [] },
        saturday: { available: false, slots: [] },
        sunday: { available: false, slots: [] },
      });
      setAvailabilityExpanded(false);
      toast.success('Department added successfully!');
    } else {
      throw new Error('Invalid response format');
    }
  } catch (error) {
    console.error('Error adding department:', error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error('Error response:', error.response.data);
        toast.error(`Failed to add department: ${error.response.data.error || 'Unknown error'}`);
      } else if (error.request) {
        console.error('No response received:', error.request);
        toast.error('Failed to add department. No response received from the server.');
      } else {
        console.error('Error setting up request:', error.message);
        toast.error(`Failed to add department: ${error.message}`);
      }
    } else {
      console.error('Non-Axios error:', error);
      toast.error('An unexpected error occurred. Please try again.');
    }
  }
};

  const openDeleteConfirmation = (branchId, deptId, type) => {
    if (!branchId || !type) {
      console.error('Invalid branchId or type in openDeleteConfirmation:', { branchId, deptId, type });
      toast.error('Invalid branch or department information.');
      return;
    }
    setDeleteConfirmation({ open: true, branchId, deptId, type });
  };

  const closeDeleteConfirmation = () => {
    setDeleteConfirmation({ open: false, branchId: null, deptId: null, type: null });
  };

const removeBranch = async () => {
    try {
      const branchId = deleteConfirmation.branchId;
      const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/branch/branches/${branchId}`);
      
      if (response.data && response.data.message === 'Branch and associated departments deleted successfully!') {
        setBranches(branches.filter(branch => branch.id !== branchId));
        toast.success('Branch and associated departments deleted successfully!');
      } else {
        throw new Error('Unexpected response from server');
      }
    } catch (error) {
      console.error('Error deleting branch:', error);
      toast.error(error.response?.data?.message || 'Failed to delete branch. Please try again.');
    } finally {
      closeDeleteConfirmation();
    }
  };
 const removeDepartment = async () => {
    const { branchId, deptId } = deleteConfirmation;
    if (!branchId || !deptId) {
      console.error('Invalid branchId or deptId:', { branchId, deptId });
      toast.error('Invalid branch or department information.');
      closeDeleteConfirmation();
      return;
    }
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/branch/${branchId}/department/${deptId}`);
      if (response.status === 200) {
        setBranches(prev =>
          prev.map(branch =>
            branch.id === branchId
              ? { ...branch, departments: branch.departments.filter(dept => dept.uniqueId !== deptId) }
              : branch
          )
        );
        toast.success('Department removed successfully!');
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (error) {
      console.error('Error removing department:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        toast.error(`Failed to remove department: ${error.response.data.message}`);
      } else {
        console.error('Error details:', error.message);
        toast.error('Failed to remove department. Please try again.');
      }
    } finally {
      closeDeleteConfirmation();
    }
  };


return (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <Container maxWidth="xl" className="py-8">
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Box p={3} height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                  <div>
                    <Typography variant="h5" gutterBottom>Add New Branch</Typography>
<Grid container spacing={2} className="bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Branch Name"
                          name="name"
                          value={newBranch.name}
                          onChange={handleBranchChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Branch Address"
                          name="address"
                          value={newBranch.address}
                          onChange={handleBranchChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          select
                          label="Country"
                          name="country"
                          value={newBranch.country}
                          onChange={handleBranchChange}
                          variant="outlined"
                        >
                          {countries.map((country) => (
                            <MenuItem key={country} value={country}>
                              {country}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          select
                          label="State"
                          name="state"
                          value={newBranch.state}
                          onChange={handleBranchChange}
                          variant="outlined"
                        >
                          {newBranch.country && states[newBranch.country].map((state) => (
                            <MenuItem key={state} value={state}>
                              {state}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="PIN Code"
                          name="pinCode"
                          value={newBranch.pinCode}
                          onChange={handleBranchChange}
                          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Availability"
                          name="availability"
                          value={newBranch.availability || ''}
                          onClick={handleOpenAvailabilityDialog}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  edge="end"
                                  onClick={handleOpenAvailabilityDialog}
                                >
                                  <ExpandMoreIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </div>
                  <Box mt={2} display="flex" justifyContent="center">
                    <ActionButton text="Add Branch" onClick={addBranch} />
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box p={3} height="100%" borderLeft={{ md: 1 }} borderColor={{ md: 'divider' }} display="flex" flexDirection="column" justifyContent="space-between">
                  <div>
                    <Typography variant="h5" gutterBottom>Add Department to Branch</Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          select
                          label="Select Branch"
                          value={selectedBranch}
                          onChange={handleBranchSelect}
                          variant="outlined"
                        >
                          {branches.map((branch) => (
                            <MenuItem key={branch.name} value={branch.name}>{branch.name}</MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          select
                          label="Department"
                          name="departmentName"
                          value={newDepartment.departmentName}
                          onChange={handleDepartmentChange}
                          variant="outlined"
                        >
                          <MenuItem value="">Select a Department</MenuItem>
                          <MenuItem value="Custom">Custom Department</MenuItem>
                          {departments.filter(dept => dept !== 'Custom').map((dept) => (
                            <MenuItem key={dept} value={dept}>{dept}</MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      {newDepartment.departmentName === 'Custom' && (
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Custom Department Name"
                            name="customDepartmentName"
                            value={newDepartment.customDepartmentName}
                            onChange={(e) => setNewDepartment(prev => ({
                              ...prev,
                              customDepartmentName: e.target.value
                            }))}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Entity Name"
                          name="entityName"
                          value={newDepartment.entityName}
                          onChange={handleDepartmentChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Entity Number"
                          name="entityNumber"
                          value={newDepartment.entityNumber}
                          onChange={handleDepartmentChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        {/* Availability box commented out
                        <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="availability-toggle">Availability</InputLabel>
                        <OutlinedInput
                          id="availability-toggle"
                          type="text"
                          value={selectedBranch ? (isLoadingAvailability ? "Loading availability..." : "Click to view/edit availability") : "Select a branch first"}
                          onClick={() => {
                            if (selectedBranch && !isLoadingAvailability) {
                              setAvailabilityExpanded(!availabilityExpanded);
                            } else if (!selectedBranch) {
                              toast.info("Please select a branch first");
                            }
                          }}
                          readOnly
                          endAdornment={
                            <InputAdornment position="end">
                              {isLoadingAvailability ? (
                                <CircularProgress size={24} />
                              ) : (
                                <IconButton
                                  edge="end"
                                  style={{
                                    transform: availabilityExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s',
                                  }}
                                  disabled={!selectedBranch || isLoadingAvailability}
                                >
                                  <ExpandMoreIcon />
                                </IconButton>
                              )}
                            </InputAdornment>
                          }
                          label="Availability"
                          style={{ cursor: selectedBranch && !isLoadingAvailability ? 'pointer' : 'not-allowed' }}
                        />
                      </FormControl>
                        */}
                      </Grid>
                    </Grid>
    {/* Availability expanded section commented out
    {availabilityExpanded && (
                      <Grid item xs={12} style={{ marginTop: '16px' }}>
                        <Grid container spacing={2}>
        {Object.keys(newEntityAvailability).map((day) => {
          const dayData = newEntityAvailability[day];
          if (!dayData || !dayData.available) return null;
          console.log(`Rendering availability for ${day}:`, JSON.stringify(dayData, null, 2));
          return (
            <Grid item xs={12} key={day}>
              <Box className="flex flex-col mb-2">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={dayData.available}
                      onChange={(e) => handleNewEntityAvailabilityChange(day, 'available', e.target.checked)}
                    />
                  }
                  label={`${day.charAt(0).toUpperCase() + day.slice(1)}`}
                />
                {dayData.slots && dayData.slots.map((slot, index) => (
                  <Box key={index} className="flex items-center ml-4 mt-1">
                    <TimePicker
                      value={slot.startTime || null}
                      onChange={(newValue) => handleNewEntityAvailabilityChange(day, 'startTime', newValue, index)}
                      renderInput={(params) => <TextField {...params} size="small" className="w-28" />}
                    />
                    <Typography className="mx-2">-</Typography>
                    <TimePicker
                      value={slot.endTime || null}
                      onChange={(newValue) => handleNewEntityAvailabilityChange(day, 'endTime', newValue, index)}
                      renderInput={(params) => <TextField {...params} size="small" className="w-28" />}
                    />
                    {index > 0 && (
                      <IconButton onClick={() => handleRemoveTimeSlot(day, index)} size="small">
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Box>
                ))}
                <Button
                  onClick={() => handleAddTimeSlot(day)}
                  startIcon={<AddIcon />}
                  className="ml-4 mt-1 self-start"
                >
                  Add Availability
                </Button>
              </Box>
            </Grid>
          );
        })}
                        </Grid>
                      </Grid>
                    )}
    */}
                  </div>
                  <Box mt={2} display="flex" justifyContent="center">
                    <ActionButton text="Add Department" onClick={addDepartment} />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={3} className="p-8 bg-white rounded-xl shadow-lg">
            <Typography variant="h5" className="mb-6 font-bold text-gray-800 flex items-center">
              <BusinessIcon className="mr-2" />
              Branches and Departments
            </Typography>
            
            <AnimatePresence>
              {loading ? (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="flex justify-center items-center h-64"
                >
                  <CircularProgress />
                </motion.div>
              ) : branches && branches.length > 0 ? (
                <motion.div className="space-y-6">
                  {console.log('Rendering branches:', JSON.stringify(branches, null, 2))}
                  {branches.map((branch, index) => (
                    <motion.div
                      key={branch.id}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: 20 }}
                      transition={{ duration: 0.3, delay: index * 0.1 }}
                      className={`bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 ${
                        editMode.type === 'branch' && editMode.id === branch.id ? 'border-0' : ''
                      }`}
                    >
                      <div className={`p-4 ${editMode.type === 'branch' && editMode.id === branch.id ? 'bg-gray-100' : 'bg-gradient-to-r from-blue-500 to-blue-600'}`}>
                        <div className="flex items-center justify-between">
                          {editMode.type === 'branch' && editMode.id === branch.id ? (
                            <div className="space-y-4 w-full bg-gray-100 p-4 rounded-lg">
                              <TextField
                                value={editData.branch.name}
                                onChange={(e) => setEditData({
                                  ...editData,
                                  branch: { ...editData.branch, name: e.target.value }
                                })}
                                label="Branch Name"
                                size="small"
                                fullWidth
                              />
                              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <TextField
                                  value={editData.branch.address}
                                  onChange={(e) => setEditData({
                                    ...editData,
                                    branch: { ...editData.branch, address: e.target.value }
                                  })}
                                  label="Address"
                                  size="small"
                                  className="bg-white rounded"
                                  fullWidth
                                />
                                <TextField
                                  select
                                  value={editData.branch.country}
                                  onChange={(e) => setEditData({
                                    ...editData,
                                    branch: { ...editData.branch, country: e.target.value }
                                  })}
                                  label="Country"
                                  size="small"
                                  className="bg-white rounded"
                                  fullWidth
                                >
                                  {countries.map((country) => (
                                    <MenuItem key={country} value={country}>{country}</MenuItem>
                                  ))}
                                </TextField>
                                <TextField
                                  select
                                  value={editData.branch.state}
                                  onChange={(e) => setEditData({
                                    ...editData,
                                    branch: { ...editData.branch, state: e.target.value }
                                  })}
                                  label="State"
                                  size="small"
                                  className="bg-white rounded"
                                  fullWidth
                                >
                                  {states[editData.branch.country || 'India'].map((state) => (
                                    <MenuItem key={state} value={state}>{state}</MenuItem>
                                  ))}
                                </TextField>
                              </div>
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                                <TextField
                                  value={editData.branch.pinCode}
                                  onChange={(e) => setEditData({
                                    ...editData,
                                    branch: { ...editData.branch, pinCode: e.target.value }
                                  })}
                                  label="PIN Code"
                                  size="small"
                                  className="bg-white rounded"
                                  fullWidth
                                />
                                <TextField
                                  value={editData.branch.availability ? 
                                    (typeof editData.branch.availability === 'string' 
                                      ? editData.branch.availability 
                                      : Object.keys(editData.branch.availability)
                                          .map(day => day.substring(0, 3).toUpperCase())
                                          .join(', ')
                                    ) 
                                    : "Click to edit availability"
                                  }
                                  onClick={handleOpenEditAvailabilityDialog}
                                  label="Availability"
                                  size="small"
                                  fullWidth
                                  className="bg-white rounded"
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </div>
                              <div className="flex justify-end space-x-2 mt-4">
                                <motion.button
                                  whileHover={{ scale: 1.05 }}
                                  whileTap={{ scale: 0.95 }}
                                  className="px-4 py-2 bg-green-500 text-white rounded-md shadow hover:bg-green-600 transition-colors"
                                  onClick={handleEditSave}
                                >
                                  Save
                                </motion.button>
                                <motion.button
                                  whileHover={{ scale: 1.05 }}
                                  whileTap={{ scale: 0.95 }}
                                  className="px-4 py-2 bg-gray-500 text-white rounded-md shadow hover:bg-gray-600 transition-colors"
                                  onClick={handleEditCancel}
                                >
                                  Cancel
                                </motion.button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="flex-1">
                                <h3 className="text-xl font-semibold text-white">{branch.name}</h3>
                                <p className="text-blue-100">{`${branch.address}, ${branch.state}, ${branch.pinCode}`}</p>
                              </div>
                              <div className="flex space-x-2">
                                <motion.button
                                  whileHover={{ scale: 1.1 }}
                                  whileTap={{ scale: 0.9 }}
                                  className="p-2 text-white hover:text-blue-200 transition-colors"
                                  onClick={() => handleEditClick('branch', branch.id, branch)}
                                >
                                  <EditIcon />
                                </motion.button>
                                <motion.button
                                  whileHover={{ scale: 1.1 }}
                                  whileTap={{ scale: 0.9 }}
                                  className="p-2 text-white hover:text-blue-200 transition-colors"
                                  onClick={() => openDeleteConfirmation(branch.id, null, 'branch')}
                                >
                                  <DeleteIcon />
                                </motion.button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>

                      <AnimatePresence>
                        {console.log(`Departments for branch ${branch.name}:`, JSON.stringify(branch.departments, null, 2))}
                        {branch.departments && Array.isArray(branch.departments) && branch.departments.length > 0 ? (
                          <motion.div
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0 }}
                            className="divide-y divide-gray-200"
                          >
                            {branch.departments.map((dept, deptIndex) => (
                              <motion.div
                                key={dept.uniqueId}
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 20 }}
                                transition={{ duration: 0.2, delay: deptIndex * 0.05 }}
                                className="p-4 hover:bg-gray-100 transition-colors"
                              >
                                {editMode.type === 'department' && editMode.id === dept.uniqueId ? (
                                  <div className="space-y-4">
                                    <TextField
                                      value={editData.department.departmentName}
                                      onChange={(e) => setEditData({
                                        ...editData,
                                        department: { ...editData.department, departmentName: e.target.value }
                                      })}
                                      label="Department Name"
                                      size="small"
                                      fullWidth
                                      className="bg-white"
                                    />
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                      <TextField
                                        value={editData.department.entityName}
                                        onChange={(e) => setEditData({
                                          ...editData,
                                          department: { ...editData.department, entityName: e.target.value }
                                        })}
                                        label="Entity Name"
                                        size="small"
                                        className="bg-white"
                                      />
                                      <TextField
                                        value={editData.department.entityNumber}
                                        onChange={(e) => setEditData({
                                          ...editData,
                                          department: { ...editData.department, entityNumber: e.target.value }
                                        })}
                                        label="Entity Number"
                                        size="small"
                                        className="bg-white"
                                      />
                                    </div>
                                    <div className="flex justify-end space-x-2">
                                      <motion.button
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                        className="px-4 py-2 bg-green-500 text-white rounded-md shadow hover:bg-green-600 transition-colors"
                                        onClick={handleEditSave}
                                      >
                                        Save
                                      </motion.button>
                                      <motion.button
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                        className="px-4 py-2 bg-gray-500 text-white rounded-md shadow hover:bg-gray-600 transition-colors"
                                        onClick={handleEditCancel}
                                      >
                                        Cancel
                                      </motion.button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                      <GroupsIcon className="text-gray-500" />
                                      <div>
                                        <h4 className="text-lg font-medium text-gray-800">{dept.departmentName || 'Unnamed Department'}</h4>
                                        <p className="text-sm text-gray-600">
                                          {dept.entityName && dept.entityNumber
                                            ? `Entity: ${dept.entityName} | ${dept.entityNumber}`
                                            : 'No entity information available'}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="flex space-x-2">
                                      <motion.button
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                        className="p-2 text-gray-600 hover:text-blue-600 transition-colors"
                                        onClick={() => handleEditClick('department', dept.uniqueId, dept)}
                                      >
                                        <EditIcon />
                                      </motion.button>
                                      <motion.button
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                        className="p-2 text-gray-600 hover:text-red-600 transition-colors"
                                        onClick={() => openDeleteConfirmation(branch.id, dept.uniqueId, 'department')}
                                      >
                                        <DeleteIcon />
                                      </motion.button>
                                    </div>
                                  </div>
                                )}
                              </motion.div>
                            ))}
                          </motion.div>
                        ) : (
                          <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className="p-4 text-center text-gray-500"
                          >
                            No departments found for this branch.
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </motion.div>
                  ))}
                </motion.div>
              ) : (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="text-center py-8 text-gray-500"
                >
                  <BusinessIcon style={{ fontSize: 48 }} className="mb-4 text-gray-400" />
                  <Typography>No branches found. Add a new branch to get started.</Typography>
                </motion.div>
              )}
            </AnimatePresence>
          </Paper>
        </Grid>
      </Grid>

      <Dialog 
        open={deleteConfirmation.open} 
        onClose={closeDeleteConfirmation}
        PaperProps={{
          className: "rounded-lg"
        }}
      >
        <DialogTitle className="bg-red-500 text-white">
          Delete {deleteConfirmation.type === 'branch' ? 'Branch' : 'Department'}
        </DialogTitle>
        <DialogContent className="mt-4">
          <DialogContentText>
            Are you sure you want to delete this {deleteConfirmation.type}?
            {deleteConfirmation.type === 'branch' && ' This will also delete all departments in this branch.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="p-4">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="px-4 py-2 bg-gray-500 text-white rounded-md shadow hover:bg-gray-600 transition-colors"
            onClick={closeDeleteConfirmation}
          >
            Cancel
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="px-4 py-2 bg-red-500 text-white rounded-md shadow hover:bg-red-600 transition-colors"
            onClick={deleteConfirmation.type === 'branch' ? removeBranch : removeDepartment}
          >
            Delete
          </motion.button>
        </DialogActions>
      </Dialog>
      
      <Toaster position="top-right" />

      <Dialog open={openAvailabilityDialog} onClose={handleCloseAvailabilityDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Set Branch Availability</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {Object.entries(branchAvailability).map(([day, { available, startTime, endTime }]) => (
              <Grid item xs={12} key={day}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography sx={{ width: '100px' }}>{day.charAt(0).toUpperCase() + day.slice(1)}</Typography>
                  <Switch
                    checked={available}
                    onChange={(e) => handleAvailabilityChange(day, 'available', e.target.checked)}
                    inputProps={{ 'aria-label': `${day} availability toggle` }}
                  />
                  {available && (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexGrow: 1 }}>
                      <TimePicker
                        value={new Date(`1970-01-01T${startTime}`)}
                        onChange={(newValue) => handleAvailabilityChange(day, 'startTime', format(newValue, 'HH:mm'))}
                        renderInput={(params) => <TextField {...params} size="small" sx={{ width: 110 }} />}
                      />
                      <Typography sx={{ mx: 1 }}>-</Typography>
                      <TimePicker
                        value={new Date(`1970-01-01T${endTime}`)}
                        onChange={(newValue) => handleAvailabilityChange(day, 'endTime', format(newValue, 'HH:mm'))}
                        renderInput={(params) => <TextField {...params} size="small" sx={{ width: 110 }} />}
                      />
                    </Box>
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAvailabilityDialog}>Cancel</Button>
          <Button onClick={handleSaveAvailability} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEditAvailabilityDialog} onClose={handleCloseEditAvailabilityDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Branch Availability</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {Object.entries(branchAvailability).map(([day, { available, startTime, endTime }]) => (
              <Grid item xs={12} key={day}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography sx={{ width: '100px' }}>{day.charAt(0).toUpperCase() + day.slice(1)}</Typography>
                  <Switch
                    checked={available}
                    onChange={(e) => handleAvailabilityChange(day, 'available', e.target.checked)}
                    inputProps={{ 'aria-label': `${day} availability toggle` }}
                  />
                  {available && (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexGrow: 1 }}>
                      <TimePicker
                        value={new Date(`1970-01-01T${startTime}`)}
                        onChange={(newValue) => handleAvailabilityChange(day, 'startTime', format(newValue, 'HH:mm'))}
                        renderInput={(params) => <TextField {...params} size="small" sx={{ width: 110 }} />}
                      />
                      <Typography sx={{ mx: 1 }}>-</Typography>
                      <TimePicker
                        value={new Date(`1970-01-01T${endTime}`)}
                        onChange={(newValue) => handleAvailabilityChange(day, 'endTime', format(newValue, 'HH:mm'))}
                        renderInput={(params) => <TextField {...params} size="small" sx={{ width: 110 }} />}
                      />
                    </Box>
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditAvailabilityDialog}>Cancel</Button>
          <Button onClick={handleSaveEditAvailability} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    </Container>
  </LocalizationProvider>
);
};

export default ContactPage;
